import { useState } from "react";
import { motion } from "framer-motion";
import { useT } from "@/i18n";
import { LANGS, LANG_TEXT, flagUrl } from "@/components/languages/content";
import { WorldScene, LangButtons, HelloBanner } from "@/components/languages/WorldParts";
import { Greetings, Alphabet, Phrases, Vocab } from "@/components/languages/Sections";

const TABS = [
  { id: "greet", img: "/img/ic-greet.webp", Comp: Greetings },
  { id: "abc", img: "/img/ic-abc.webp", Comp: Alphabet },
  { id: "phrases", img: "/img/ic-phrases.webp", Comp: Phrases },
  { id: "vocab", img: "/img/vocab/apple.webp", Comp: Vocab },
];

export default function LanguagesWorkshop() {
  const { lang } = useT();
  const tx = LANG_TEXT[lang];
  const [target, setTarget] = useState(lang === "es" ? "en" : "es");
  const [tab, setTab] = useState("greet");
  const [mascot, setMascot] = useState("lumi");
  const current = LANGS.find((l) => l.id === target);
  const Active = TABS.find((t) => t.id === tab).Comp;

  return (
    <section className="learn-bg rounded-[2rem] border-4 border-white shadow-xl p-4 sm:p-8 mt-8 space-y-8" data-testid="languages-workshop">
      <WorldScene target={target} setTarget={setTarget} />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {TABS.map((t) => (
          <motion.button
            key={t.id}
            type="button"
            whileHover={{ y: -4 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => setTab(t.id)}
            className={`bg-white rounded-[1.75rem] border-4 ${tab === t.id ? "border-yellow-300 ring-4 ring-yellow-200" : "border-white"} shadow-lg p-4 flex flex-col items-center justify-center gap-2 min-h-[9rem]`}
            data-testid={`lang-tab-${t.id}`}
          >
            <img src={t.img} alt="" className="h-14 sm:h-16 w-auto object-contain" />
            <span className="font-fredoka text-lg sm:text-2xl font-bold text-blue-900 text-center leading-tight">{tx[t.id]}</span>
          </motion.button>
        ))}
      </div>
      <LangButtons target={target} setTarget={setTarget} />
      <div className="bg-white/60 rounded-[2rem] p-4 sm:p-6">
        <p className="mb-4 inline-flex items-center gap-2 bg-white rounded-full pl-1 pr-4 py-1 font-bold text-blue-950 shadow" data-testid="lang-current">
          <img src={flagUrl(current.flag)} alt="" className="w-8 h-8 rounded-full object-cover" />
          {tx.learning}: {current.label} · {tx[tab]} · <span className="text-blue-600 text-sm">{tx.tapListen}</span>
        </p>
        <div className="mb-4 flex flex-wrap items-center gap-2" data-testid="lang-teacher-picker">
          <span className="font-bold text-blue-950">{tx.who}</span>
          {["lumi", "spark"].map((m) => (
            <button key={m} type="button" onClick={() => setMascot(m)} className={`rounded-full pl-1 pr-4 py-1 font-fredoka font-bold inline-flex items-center gap-2 shadow border-4 ${mascot === m ? (m === "lumi" ? "bg-yellow-300 border-yellow-400 text-blue-950" : "bg-sky-400 border-sky-500 text-white") : "bg-white border-white text-blue-900"}`} data-testid={`lang-teacher-${m}`}>
              <img src={`/img/${m}.webp`} alt="" className="w-9 h-9 object-contain" /> {m === "lumi" ? "Lumi" : "Spark"}
            </button>
          ))}
        </div>
        <Active target={target} mascot={mascot} />
      </div>
      <HelloBanner />
    </section>
  );
}
